import React from 'react';

export const ReporteImpresion = ()=>{
    return <div>
        <h1>Reporte impresión</h1>
    </div>
}